<template>
<div class="">

    <div class="row mx-0 mt-3 p-3 d-flex justify-content-start">
        <div class="col-xl-4 col-lg-6 col-md-12 border mb-3 p-3">
            <cPatient v-if="optionShow == 0" :patient="patient" :dataTableImages="jsonData" @toggleVisibilityGraph="toggleVisibilityGraph"></cPatient>
            <div v-if="optionShow == 1" id="div-informe" class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="row d-flex justify-content-start align-items-center">
                        <div class="col-xl-auto col-md-4 col-sm-4 mt-2">
                            <div class="mt-1 mb-1 ms-auto btn-success">
                                <button type="button" class="btn btn-sm btn-outline-main w-100" @click="mtdChangeOption()">
                                    <i class="fas fa-arrow-left"></i> Atrás
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row px-3">
                        <div class="my-2 border-top border-bottom">
                            <span class="text-center">Informe {{ itemImagen.dateCreated }}</span>
                        </div>
                        <div class="text-start">
                                <p class="ps-2 text-xs"> > Indicacion para {{ itemImagen.patient.indicacion.value }}</p>
                            </div>
                        <div class="ps-3">
                            <div class="text-start">
                                <div class="mb-1">
                                    <span class="fst-italic"><b>Conclusiones</b></span>
                                </div>
                                <div v-for="(item, index) in itemImagen.details.conclusiones" :key="index">
                                    <span class="text-xs">Número</span>
                                    <p class="fw-light ps-2 text-xs"> {{ item.ojo }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="text-start">
                                <div class="mb-1">
                                    <span class="fst-italic"><b>Conclusiones Generales:</b></span>
                                </div>
                                <span class="text-xs">Ojo derecho</span>
                                <dl class="row" v-for="(item, index) in itemImagen.conclusiones.value" :key="index">
                                    <dd class="col-sm-12 text-xs">{{item.name}} - {{ item.ojo }}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!---Imagen-->
        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 px-3" v-if="isVisibleResultArray[pos] == true">
            <div class="row rounded-5 d-flex justify-content-center border-2 h-100 p-2" id="div-img-campovisual">
                <div id="carouselExampleIndicators" class="carousel slide home-carousel mt-0" data-bs-ride="carousel" v-if="dataImg.length > 0">
                    <div class="carousel-indicators">
                        <button v-for="(imagen, index) in dataImg" :key="index" type="button" :data-bs-target="'#carouselExampleIndicators'" :data-bs-slide-to="index" :class="{ 'active': index === 0 }" aria-current="true" :aria-span="'Slide ' + (index + 1)"></button>
                    </div>
                    <div class="carousel-inner">
                        <div v-for="(imagen, index) in dataImg" :key="index" :class="{ 'carousel-item': true, 'active': index === 0 }">
                            <img :src="'https://oftalmologia.howertpi.com/assets/'+imagen.route" class="d-block w-100" @click="mtOpenCarrusel" :data-bs-slide-to="index" alt="...">
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
                <div class="h-100 p-5" v-if="dataImg.length == 0">
                    <h3>No hay Imagenes para mostrar</h3>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-md-6 col-lg-6 col-sm-12  px-0" v-if="isVisibleResultArray[pos] == true">
            <div class="row rounded-5 border-2 h-100" id="div-img-campovisual">
                <div class="justify-content-center p-1 z-index-button" v-if="dataPdf[0]">
                    <iframe :src="'https://oftalmologia.howertpi.com/assets/'+dataPdf[0].route" width="100%" height="600px" title="Pdf"></iframe>
                </div>
                <div class="justify-content-center p-5 z-index-button" v-if="!dataPdf[0]">
                    <h3>No hay Archivos para mostrar</h3>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <cCarrusel :title="modal.title" :boo_modal="modal.boo_modal" :dataImg="dataImg" @closeCarrusel="closeCarrusel" />

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
import cPatient from '@/components/Medico/AyudaDx/cPatient.vue'
import cCarrusel from '@/components/Medico/AyudaDx/modals/cCarrusel.vue';
export default {
    name: 'c-medico-paquimetria',
    components: {
        VuePdfApp,
        cPatient,
        cCarrusel
    },
    data() {
        return {
            page: 'paquimetria',
            stateHistory: null,
            viewInput: null,
            pos: 0,
            patient_id: "",
            optionShow: 0,
            select_patient: null,
            state: false,
            jsonData: [],
            dataPdf: [],
            dataImg: [],
            isVisibleResultArray: [],
            itemImagen: {},
            modal:{
                title:'',
                boo_modal:false
            }
        }
    },
    props: {
        stateRolAdmin: Boolean,
        patient: {
            type: Object,
        },
        data: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        lengthArray() {
            return this.data.length;
        }
    },
    mounted() {
        this.mtdConversionData();
        for (let i = 0; i < this.lengthArray; i++) {
            let atributo = false;
            this.isVisibleResultArray.push(atributo);
        }

    },
    methods: {
        ...mapActions(['get', 'post']),
        mtdConversionData: function () {
            this.data.forEach(element => {
                const jsonDataFromBackend = JSON.parse(element);
                this.jsonData = this.jsonData.concat(jsonDataFromBackend);
            });
        },
        toggleVisibilityGraph: function (pos) {
            this.$set(this.isVisibleResultArray, pos, true);
            this.pos = pos;
            this.optionShow = 1;
            this.itemImagen = this.jsonData[pos];
            //separar pdf de img
            this.jsonData[pos].patient.examen.value.forEach(elem => {
                const extension = elem.route.split('.').pop().toLowerCase();
                if (extension === 'pdf') {
                    this.dataPdf.push(elem);
                } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
                    this.dataImg.push(elem);
                }

            });
        },
        mtd_add: function () {
            let conclusion = {
                name: "Conclusion",
                numero: "",
                ojo: "OD",
            };
            this.conclusiones = this.conclusiones.concat(conclusion);
        },
        mtd_delete: function (index) {
            this.conclusiones.splice(index, 1);
        },
        mtdGetStyle: function (option) {
            if (option == this.page) return 'background: #900052';
            return '';
        },
        mtdGetStyleSpan: function (option) {
            if (option == this.page) return 'color:white';
            return '';
        },
        changePage: function (page) {
            this.page = page;
            if (page === 'cola') {
                this.patients = {}
            }
            this.stateHistory = (page === 'paquimetria') ? 1 : 0;
            this.viewInput = (page === 'paquimetria') ? 1 : 0;
        },
        returnHome() {
            this.$emit('mtdChangePage', 'home')
        },
        mtdChangeOption() {
            this.optionShow = 0;
            this.state = !this.state;
            for (let i = 0; i < this.lengthArray; i++) {
                this.$set(this.isVisibleResultArray, i, false);
            }
        },
        mtdviewpage: function (payload) {
            this.page = 'paquimetria'
            this.stateHistory = 0;
            this.patients = payload;
            this.viewInput = 0;
        },
        mtOpenCarrusel: function (){
            this.modal = {
                title: 'RESULTADOS PAQUIMETRIA - ' + this.patient.name,
                boo_modal: true, 
            }
        },
        closeCarrusel: function(){
            this.modal.title = '';
            this.modal.boo_modal = false;
        }

    }
}
</script>
